module.exports = __webpack_public_path__ + "static/media/xlm.29ac2fa4.svg";